import { render } from "./BetSlipSubmitResponse.vue?vue&type=template&id=5b4f2724&scoped=true"
import script from "./BetSlipSubmitResponse.vue?vue&type=script&lang=js"
export * from "./BetSlipSubmitResponse.vue?vue&type=script&lang=js"

import "./BetSlipSubmitResponse.vue?vue&type=style&index=0&id=5b4f2724&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4f2724"]])

export default __exports__